import styled from 'styled-components';

import { wideBreakpoints } from '@r1-frontend/ui-react/components/layouts/wideContainer';
import { BorderRadius } from '@r1-frontend/ui-react/tokens/borderRadius';
import { COLORS } from '@r1-frontend/ui-react/tokens/colors';
import { FONTS } from '@r1-frontend/ui-react/tokens/fonts';

export const TypeWrapper = styled.div<{ isActive: boolean }>`
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    padding: 2px;
    border-width: 2px;
    border-style: solid;
    border-color: ${({ isActive }) => isActive ? COLORS.Outline_Dark : 'transparent'};
    border-radius: 34px;
    background-color: transparent;
    transition: .2s;
    cursor: pointer;

    @media (max-width: ${wideBreakpoints.tablet}) {
        border-radius: 18px;
    }
`;

export const TypeContent = styled.div`
    width: 100%;
    height: 100%;
    padding: 24px;
    gap: 20px;
    border-radius: ${BorderRadius.OuterBlockRadius};
    background-color: ${COLORS.BgSurface};
    align-content: space-between;

    button {
        margin-top: auto;
        width: 100%;
    }

    @media (max-width: ${wideBreakpoints.tablet}) {
        padding: 12px;
        gap: 16px;
        border-radius: ${BorderRadius.componentRadius};
    }
`;

export const TypeDescription = styled.div`
    gap: 4px;
    flex-direction: column;
    width: 100%;
`;

export const TitleBlock = styled.div`
    flex-direction: column;
    gap: 8px;

    @media (max-width: ${wideBreakpoints.tablet}) {
        flex-direction: row-reverse;
        flex-wrap: nowrap;
        justify-content: space-between;
        align-items: center;
        gap: 4px;
    }

    @media (max-width: ${wideBreakpoints.mobile}) {
        height: 40px;
    }
`;

export const Icon = styled.div`
    align-content: center;

    @media (max-width: ${wideBreakpoints.tablet}) {
        width: 24px;
        height: 24px;
    }
`;

export const Title = styled.p`
    ${FONTS.H5};
    margin: 0;

    @media (max-width: ${wideBreakpoints.mobile}) {
        ${FONTS.H6};
    }
`;

export const PriceBlock = styled.div`
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-between;
    align-items: center;
`;

export const Price = styled(Title)`
    white-space: nowrap;
`;

export const Info = styled.p`
    ${FONTS.S};
    color: ${COLORS.TextSecondary};
    margin: 0;
    white-space: pre-wrap;

    @media (max-width: ${wideBreakpoints.tablet}) {
        ${FONTS.XS};
    }
`;
